var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnblockOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 3.89998C7.52659 3.89998 3.9001 7.52647 3.9001 12C3.9001 16.4735 7.52659 20.1 12.0001 20.1C16.4736 20.1 20.1001 16.4735 20.1001 12C20.1001 7.52647 16.4736 3.89998 12.0001 3.89998ZM2.1001 12C2.1001 6.53236 6.53248 2.09998 12.0001 2.09998C17.4677 2.09998 21.9001 6.53236 21.9001 12C21.9001 17.4676 17.4677 21.9 12.0001 21.9C6.53248 21.9 2.1001 17.4676 2.1001 12Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00009 12C7.00009 11.5029 7.40304 11.1 7.90009 11.1H16.1001C16.5971 11.1 17.0001 11.5029 17.0001 12C17.0001 12.497 16.5971 12.9 16.1001 12.9H7.90009C7.40304 12.9 7.00009 12.497 7.00009 12Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnblockOutline);
export default __webpack_public_path__ + "static/media/unblock_outline.923e4bb6b3b7b465c87165849c27e516.svg";
export { ForwardRef as ReactComponent };